<template>
    <v-container fluid>
        <email-form
            :model="email"
            @saved="saved"
            :titlePrefix="$t('emails-create.texts.title-prefix')"
        ></email-form>
    </v-container>
</template>

<script>
import EmailModel from '@/models/Email'
import EmailForm from './Form'

export default {
    components: {
        'email-form': EmailForm,
    },

    data: () => {
        return {
            email: new EmailModel(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: 'emails' })
        },
    },
}
</script>
